import {
    Component, Mixins,
} from 'vue-property-decorator';
import Classes from '@components/shared/mixins/classes';
import { YIcon } from '@components/index';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Breadcrumb
 */
@Component({
    components: {
        YIcon,
    },
})
class YBreadcrumb extends Mixins(Props, Classes) {
    /**
     * Breadcrumb items that show the breadcrumb
     */
    refactorItems: Array<string | unknown> = [];

    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size', 'rounded', 'raised', 'pill', 'bordered'];

    /**
     * Create Common Props for the breadcrumb.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> { // eslint-disable-line @typescript-eslint/no-explicit-any
        const commonProps: Record<string, any> = { // eslint-disable-line @typescript-eslint/no-explicit-any
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the breadcrumb.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Breadcrumb', this.commonProps, this.baseClass || config.prefix.breadcrumb));
        if (this.hasBg) {
            cls.push('is-has-bg');
        }
        if (this.linkBg) {
            cls.push('is-link-bg');
        }
        // if (this.responsive) {
        //     cls.push('is-responsive');
        // }
        return cls;
    }

    /**
     * Return the class of the breadcrumb from config.
     * 
     * @returns {string}
     */
    get breadcrumbClass(): string {
        return config.prefix.breadcrumb;
    }

    /**
     * @inheritDoc
     */
    mounted(): void {
        this.sortItems();
    }

    // TODO - Commented for declear prop error
    /**
     * Set breadcrumb items.
     */
    sortItems(): void {
        const newItems = [...this.items];
        // if (this.responsive) {
        //     const sort: Array<string | unknown> = [];
        //     if (this.items.slice(1, this.items.length - parseInt(this.lastItems.toString(), 10)).length) {
        //         sort.push(newItems[0]);
        //         sort.push({
        //             title   : '...',
        //             children: newItems.slice(1, newItems.length - parseInt(this.lastItems.toString(), 10)),
        //         });
        //         const popArr: Array<string | unknown> = [];
        //         // eslint-disable-next-line no-plusplus
        //         for (let i = 1; i <= this.lastItems; i++) {
        //             popArr.unshift(newItems.pop());
        //         }
        //         sort.push(...popArr);
        //     } else {
        //         sort.push(...newItems);
        //     }
        //     this.refactorItems = sort;
        // } else {
           
        // }
        this.refactorItems = newItems;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    numbers: Record<string, any> = {
        fa: ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
        ar: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
        en: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    }

    /**
     * Converts English digits into asked locale formatted number.
     *
     * @param {number} digit - The number to convert
     * @param {number} locale - The locale to convert
     * @returns {string}
     */
    digits = (digit: number, locale = this.lang): string => `${digit}`
        .replace(/[0123456789]/g, (w) => this.numbers[locale][this.numbers.en.indexOf(w)])
        .replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (w) => this.numbers[locale][this.numbers.fa.indexOf(w)])
        .replace(/[٠١٢٣٤٥٦٧٨٩]/g, (w) => this.numbers[locale][this.numbers.ar.indexOf(w)])
}

export default YBreadcrumb;
